<template>
  <div class="game-name-position">
    <router-link to="/" class="game-name">Cat and Lillies</router-link>
  </div>
  <router-view/>
</template>

<style>
@import "~@fontsource/neuton/400.css";

.game-name-position {
  padding: 2rem;
}

.game-name {
  font-family: "Neuton";
  font-size: 40px;
  padding: 10px;
  text-decoration: none;
  color: black;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
